"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class KeyStrokeMatcher {
    static matches(keyStroke, event) {
        var _a, _b;
        const key = ((_a = event.key) !== null && _a !== void 0 ? _a : '').toLowerCase();
        const keyCode = ((_b = event.code) !== null && _b !== void 0 ? _b : '').toLowerCase();
        return (keyCode === keyStroke.key || key === keyStroke.key)
            && keyStroke.ctrl === event.ctrlKey
            && keyStroke.alt === event.altKey
            && keyStroke.shift === event.shiftKey;
    }
}
exports.default = KeyStrokeMatcher;
//# sourceMappingURL=KeyStrokeMatcher.js.map